import { render, staticRenderFns } from "./mbApplicationresults.vue?vue&type=template&id=5a998197&scoped=true&"
import script from "./mbApplicationresults.vue?vue&type=script&lang=js&"
export * from "./mbApplicationresults.vue?vue&type=script&lang=js&"
import style0 from "./mbApplicationresults.vue?vue&type=style&index=0&id=5a998197&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a998197",
  null
  
)

export default component.exports